import {MonitoringServer} from "@/lib/types/monitoring.ts";
import {MetaData} from "@/pages/checks/components/form/fields/legacy/testRunnerTypes.tsx";

export const TestRunServerInfo = ({testServer, meta}: {testServer?: MonitoringServer; meta?: MetaData}) => {
  if (!meta?.hostname || !meta?.addresses) {
    return (
      <div className="pulseTextBodySmall pulse-color-gray-700 text-break">
        <div className="mb-2">{testServer?.name || ""}</div>
        <div>[{testServer?.address_ipv4 || ""}]</div>
        <div>[{testServer?.address_ipv6 || ""}]</div>
      </div>
    );
  }

  return (
    <div className="pulseTextBodySmall pulse-color-gray-700 text-break">
      <div className="mb-2">{meta?.hostname || ""}</div>
      <div>[{meta?.addresses[0] || ""}]</div>
      <div>[{meta?.addresses[1] || ""}]</div>
    </div>
  );
};
